import { applyMiddleware, compose, createStore } from "redux";
import rootReducer from "./reducers";
import rootMiddleware from "./middleware";
import createSagaMiddleware from "redux-saga";

/*eslint-disable */
const composeSetup = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose;
/*eslint-enable */

const sagaMiddleware = createSagaMiddleware();

// compose the middleware with additional (optional) enhancers
// const enhancer = compose();

// create and configure the store
export const store = createStore(
  rootReducer,
  composeSetup(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootMiddleware);



// WEBPACK FOOTER //
// ./src/redux/store.js